import { StyleSheet } from 'react-native';
import { t } from '@lingui/macro';
import styled from 'styled-components/native';

import TextInput from '@src/components/TextInput';
import { i18n } from '@src/i18n';

export const CommentInput = styled(TextInput).attrs({
  compact: true,
  placeholder: i18n._(t`Write your comment`),
  underlineColor: 'transparent',
  // multiline: true,
})``;

export const Separator = styled.View`
  border-top-width: ${StyleSheet.hairlineWidth}px;
  opacity: 0.2;
  margin: 10px;
`;

export const CommentInputContainer = styled.View`
  flex-direction: row;
  align-items: center;
  border-width: 0;
  border-top-color: ${({ theme }) => theme.colors.disabled};
  border-top-width: ${StyleSheet.hairlineWidth}px;
  background-color: ${({ theme }) => theme.colors.background};
`;
